import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';
import {validations} from './../../../lib/validations';
import {withRouter} from 'react-router';

const mapStateToProps = (state: any) => ({
  users: state.users,
  initialValues: state.users.detail,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      users: bindActionCreators(actions.users, dispatch),
    },
  };
};

export const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'usersEdit',
    validate: validations.users,
    enableReinitialize: true,
  }),
  withRouter
);
